// extracted by mini-css-extract-plugin
export var bottomCircle = "bL_hp";
export var content = "bL_cf";
export var description = "bL_dn";
export var hide = "bL_z";
export var icon = "bL_bw";
export var image = "bL_d";
export var imageContainer = "bL_ht";
export var left = "bL_bS";
export var nextYear = "bL_hs";
export var right = "bL_bV";
export var section = "bL_b";
export var shrink = "bL_hr";
export var title = "bL_f";
export var topCircle = "bL_hn";
export var wave = "bL_fB";
export var waveContainer = "bL_dY";
export var year = "bL_hq";